module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Da-Eb-Fb.e2ed2087.png";